import HomePage from './homePage.container';

export default HomePage;
